import { useMemo } from 'react';

export const useSeedProviderValue = ({
  state,
  dispatch,
  collaboration,
  resource,
  workspace,
  budget,
  transactions,
  sponsorship,
  entity,
  preferences,
  project,
  donationsState,
  donationsActions,
  onboarding
}) =>
  useMemo(
    () => ({
      ...state,
      dispatch,
      updateTeamProjectsInSeed: collaboration.updateTeamProjectsInSeed,
      removeTeamProjectFromSeed: collaboration.removeTeamProjectFromSeed,
      getSeed: resource.getSeed,
      getCategory: budget.getCategory,
      fetchSeedBanners: workspace.fetchSeedBanners,
      fetchSeedSetupStatus: workspace.fetchSeedSetupStatus,
      refreshSeedAnnouncements: workspace.refreshSeedAnnouncements,
      dismissBanner: workspace.dismissBanner,
      createSeed: entity.createSeed,
      getUserSeed: resource.getUserSeed,
      getAllseeds: resource.getAllseeds,
      getPlans: collaboration.getPlans,
      getIncome: transactions.getIncome,
      getActions: collaboration.getActions,
      getExpenses: transactions.getExpenses,
      getComments: collaboration.getComments,
      comments: collaboration.comments,
      getTeamsBySeed: collaboration.getTeamsBySeed,
      getTeam: collaboration.getTeam,
      teams: collaboration.teams,
      teamsLoading: collaboration.teamsLoading,
      createIncome: transactions.createIncome,
      createAction: collaboration.createAction,
      createExpense: transactions.createExpense,
      prefetchTransactions: transactions.prefetchTransactions,
      refreshTransactionData: transactions.refreshTransactionData,
      clearTransactionCache: transactions.clearTransactionCache,
      createComment: collaboration.createComment,
      createTeam: collaboration.createTeam,
      updateTeam: collaboration.updateTeam,
      getIncomeCategory: budget.getIncomeCategory,
      getExpsenseTotal: transactions.getExpsenseTotal,
      getIncomeTotal: transactions.getIncomeTotal,
      incomeTotal: transactions.incomeTotal,
      incomeBudgets: transactions.incomeBudgets,
      expenseTotal: transactions.expenseTotal,
      getUserPreferences: preferences.getUserPreferences,
      getSeedPreferences: preferences.getSeedPreferences,
      getSeedOperations: preferences.getSeedOperations,
      updateSeedOperations: preferences.updateSeedOperations,
      updateUserPreferences: preferences.updateUserPreferences,
      updateSeedPreferences: preferences.updateSeedPreferences,
      income: transactions.income,
      expenses: transactions.expenses,
      transactions: transactions.transactions,
      transactionsLoading: transactions.transactionsLoading,
      transactionsError: transactions.transactionsError,
      getTransactions: transactions.getTransactions,
      queryTransactions: transactions.queryTransactions,
      budgets: state?.budgets,
      donations: donationsState.donations,
      donationsLoading: donationsState.donationsLoading,
      donationsError: donationsState.donationsError,
      donationSubmitting: donationsState.donationSubmitting,
      fetchDonations: donationsActions.fetchDonations,
      addManualDonation: donationsActions.addManualDonation,
      transactionsSeedId: transactions.transactionsSeedId,
      actions: collaboration.actions,
      getTransactionCategory: budget.getTransactionCategory,
      createBudgeCategories: budget.createBudgeCategories,
      budgetCategories: budget.budgetCategories,
      standardBudgetPlans: budget.standardBudgetPlans,
      setStandardBudgetPlan: budget.setStandardBudgetPlan,
      getStandardBudgetPlan: budget.getStandardBudgetPlan,
      clearStandardBudgetPlan: budget.clearStandardBudgetPlan,
      fetchStandardBudgetPlan: budget.fetchStandardBudgetPlan,
      budgetDetails: budget.budgetDetails,
      fetchBudgetDetail: budget.fetchBudgetDetail,
      updateBudgetStatus: budget.updateBudgetStatus,
      softDeleteBudget: budget.softDeleteBudget,
      updateBudget: budget.updateBudget,
      createStandardBudgetEntry: budget.createStandardBudgetEntry,
      updateStandardBudgetEntry: budget.updateStandardBudgetEntry,
      deleteStandardBudgetEntry: budget.deleteStandardBudgetEntry,
      reorderStandardBudgetEntries: budget.reorderStandardBudgetEntries,
      fetchChildBudgetSummary: budget.fetchChildBudgetSummary,
      childBudgetSummaries: budget.childBudgetSummaries,
      createBudget: budget.createBudget,
      createBudgetFromPreview: budget.createBudgetFromPreview,
      createBudgetEstimate: budget.createBudgetEstimate,
      getBudgets: budget.getBudgets,
      incomeChartData: transactions.incomeChartData,
      expenseChartData: transactions.expenseChartData,
      createChild: entity.createChild,
      getChild: entity.getChild,
      getChildren: entity.getChildren,
      kids: entity.kids,
      childrenTotal: entity.childrenTotal,
      childrenSponsored: entity.childrenSponsored,
      childrenPending: entity.childrenPending,
      childrenPageSize: entity.childrenPageSize,
      toggleChildVisibility: entity.toggleChildVisibility,
      updateChildPhoto: entity.updateChildPhoto,
      removeChildLocally: entity.removeChildLocally,
      upsertChildLocally: entity.upsertChildLocally,
      createChildExpense: transactions.createChildExpense,
      createChildIncome: transactions.createChildIncome,
      getChildExpense: transactions.getChildExpense,
      getChildIncome: transactions.getChildIncome,
      childTransactions: transactions.childTransactions,
      childYesterdayTransactions: transactions.childYesterdayTransactions,
      childTotalTransactions: transactions.childTotalTransactions,
      childYDiffFromLastWeek: transactions.childYDiffFromLastWeek,
      childTodayTransactions: transactions.childTodayTransactions,
      childCurrentMonthTotal: transactions.childCurrentMonthTotal,
      childLastMonthTotal: transactions.childLastMonthTotal,
      childDiffFromLastMonth: transactions.childDiffFromLastMonth,
      childYesterdayTotal: transactions.childYesterdayTotal,
      childTodayTotal: transactions.childTodayTotal,
      childWeeklyChart: transactions.childWeeklyChart,
      childIncomeTransactions: transactions.childIncomeTransactions,
      childIncomeYesterdayTransactions:
        transactions.childIncomeYesterdayTransactions,
      childIncomeTotalTransactions: transactions.childIncomeTotalTransactions,
      childIncomeYDiffFromLastWeek: transactions.childIncomeYDiffFromLastWeek,
      childIncomeTodayTransactions: transactions.childIncomeTodayTransactions,
      childIncomeCurrentMonthTotal: transactions.childIncomeCurrentMonthTotal,
      childIncomeLastMonthTotal: transactions.childIncomeLastMonthTotal,
      childIncomeDiffFromLastMonth: transactions.childIncomeDiffFromLastMonth,
      childIncomeYesterdayTotal: transactions.childIncomeYesterdayTotal,
      childIncomeTodayTotal: transactions.childIncomeTodayTotal,
      childIncomeWeeklyChart: transactions.childIncomeWeeklyChart,
      childIncomeLoading: transactions.childIncomeLoading,
      childIncomeError: transactions.childIncomeError,
      createChildStatusUpdate: sponsorship.createChildStatusUpdate,
      getChildStatusUpdate: sponsorship.getChildStatusUpdate,
      getChildStatusUpdates: sponsorship.getChildStatusUpdates,
      editChildStatusUpdate: sponsorship.editChildStatusUpdate,
      deleteChildStatusUpdate: sponsorship.deleteChildStatusUpdate,
      childStatusUpdates: sponsorship.childStatusUpdates,
      campaigns: sponsorship.campaigns,
      campaignsTotal: sponsorship.campaignsTotal,
      campaignsLoading: sponsorship.campaignsLoading,
      campaignsError: sponsorship.campaignsError,
      campaignSubmitting: sponsorship.campaignSubmitting,
      campaignCategories: sponsorship.campaignCategories,
      campaignCategoriesLoading: sponsorship.campaignCategoriesLoading,
      campaignCategoriesError: sponsorship.campaignCategoriesError,
      campaignBudgets: sponsorship.campaignBudgets,
      getCampaignMeta: sponsorship.getCampaignMeta,
      getCampaigns: sponsorship.getCampaigns,
      createCampaign: sponsorship.createCampaign,
      teamEvents: state.teamEvents,
      teamEventsLoading: state.teamEventsLoading,
      teamEventsError: state.teamEventsError,
      teamEventSubmitting: state.teamEventSubmitting,
      fetchTeamEvents: sponsorship.fetchTeamEvents,
      createTeamEvent: sponsorship.createTeamEvent,
      communicationChannelsBySeed: workspace.communicationChannelsBySeed,
      communicationChannelsLoading: workspace.communicationChannelsLoading,
      communicationChannelsError: workspace.communicationChannelsError,
      fetchCommunicationChannelsForSeed:
        workspace.fetchCommunicationChannelsForSeed,
      getCommunicationChannelsForSeed:
        workspace.getCommunicationChannelsForSeed,
      getFinancialData: budget.getFinancialData,
      updateSeedTransactionCategories: project.updateSeedTransactionCategories,
      updateBudgetEstimatesInProject: project.updateBudgetEstimatesInProject,
      updateProjectUpdatesInProject: project.updateProjectUpdatesInProject,
      updateContributionMeansInProject:
        project.updateContributionMeansInProject,
      getContributionMeans: budget.getContributionMeans,
      aiTeammateAliases: workspace.aiTeammateAliases,
      aiTeammateAvatars: workspace.aiTeammateAvatars,
      fetchAiTeammateAlias: workspace.fetchAiTeammateAlias,
      renameAiTeammate: workspace.renameAiTeammate,
      updateAiTeammateAvatar: workspace.updateAiTeammateAvatar,
      updateSeedDetails: resource.updateSeedDetails,
      followSeed: workspace.followSeed,
      unfollowSeed: workspace.unfollowSeed,
      followSeeds: workspace.followSeeds,
      unfollowSeeds: workspace.unfollowSeeds,
      seedFollowRequests: state.seedFollowRequests,
      seedFollowErrors: state.seedFollowErrors,
      onboardingState: onboarding.onboardingState,
      updateOnboardingState: onboarding.updateOnboardingState,
      resetOnboardingState: onboarding.resetOnboardingState,
      sectors: workspace.sectors,
      sectorsLoading: workspace.sectorsLoading,
      sectorsError: workspace.sectorsError,
      fetchSectors: workspace.fetchSectors
    }),
    [
      state,
      dispatch,
      collaboration,
      resource,
      workspace,
      budget,
      transactions,
      sponsorship,
      entity,
      preferences,
      project,
      donationsState,
      donationsActions,
      onboarding
    ]
  );
